import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Input,
  OnDestroy,
} from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { takeUntil } from 'rxjs/operators/takeUntil';
import { consensoVeloceConditionsText } from '../../../models/contitions';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AlgConsensoService } from '../../../services/alg-consenso.service';
import { CambioPiano } from '../../../models/fisso';
import { ApiService } from '../../../services/api.service';

@Component({
  selector: 'alg-change-plan-general-condition',
  templateUrl: './alg-change-plan-general-condition.component.html',
  styleUrls: ['./alg-change-plan-general-condition.component.scss'],
})
export class AlgChangePlanGeneralConditionComponent
  implements OnInit, OnDestroy {
  @Output() checkboxOutputConsents = new EventEmitter<boolean>();
  @Input() checkboxInput: Object = {};
  @Input() changePlan: CambioPiano;
  @Input() isProductGasVulnerable: boolean;

  public contractForm: FormGroup;
  public policiesUrls: any = {};
  private opportunityCategoryNumber: number;
  private ngUnsubscribe = new Subject<void>();
  public consentsContent: any;
  public clauseContent: any;
  public supplyType = null;
  public placet = null;
  public isUnipol: boolean;
  public controlCheckboxesClause: boolean;
  public controlCheckboxesConsents: boolean;
  public cteLink: string;
  public cgfLink: string;
  public productGasVulnerable: boolean;
  public productName: string;

  public readAcceptances = {
    consents: false,
  };

  public readAcceptance = {
    consentsCondition: false,
  };

  constructor(
    private consensoSerivce: AlgConsensoService,
    private api: ApiService
  ) { }

  ngOnInit() {
    // SUBSCRIBE: Save a local copy of policies urls
    this.consensoSerivce.policiesUrl$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((policies) => {
        this.policiesUrls = policies;
      });

    // SUBSCRIBE: Save a local copy of opportunity category number
    this.consensoSerivce.categoryNumber$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((opportunityCategoryNumber) => {
        this.opportunityCategoryNumber = opportunityCategoryNumber;
      });

    this.contractForm = new FormGroup({
      consentsCondition: new FormControl(
        this.readAcceptance.consentsCondition,
        {
          validators: [Validators.requiredTrue],
        }
      ),
    });

    this.contractForm.valueChanges.subscribe((data) => {
      this.readAcceptance.consentsCondition = data.consentsCondition;
    });

    this.clauseContent =
      consensoVeloceConditionsText.clause.get(this.opportunityCategoryNumber) ||
      consensoVeloceConditionsText.clause.get(0);

    this.convertFornitureCGFToString(this.changePlan);
  }

  ngOnChanges() {
    this.productGasVulnerable = this.isProductGasVulnerable;
    this.productName = this.changePlan.NewProductName;
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  private convertFornitureCGFToString(changePlan: CambioPiano) {
    // EE
    if (changePlan.isLight && !changePlan.isGas) {
      this.changePlan.cgfLink =
        'https://s3.eu-central-1.amazonaws.com/documenti.lucegasecoop.it/fisso/CGF/ALLA-CGF-EE.pdf';
    }
    // DUAL
    if (changePlan.isLight && changePlan.isGas) {
      this.changePlan.cgfLink =
        'https://s3.eu-central-1.amazonaws.com/documenti.lucegasecoop.it/fisso/CGF/ALLA-CGF-DUAL.pdf';
    }
    // GAS
    if (!changePlan.isLight && changePlan.isGas) {
      this.changePlan.cgfLink =
        'https://s3.eu-central-1.amazonaws.com/documenti.lucegasecoop.it/fisso/CGF/ALLA-CGF-GAS.pdf';
    }
  }

  handlerRenew(product, frequency) {
    if (product.includes('Vulnerabile')) {
      return null;
    } else {
      if (frequency === 'Bimestrale') {
        return 'Rinnovo';
      } else {
        return 'RinnovoM';
      }
    }
  }

  downloadCTE() {
    console.log('ChangePlan', this.changePlan);
    const commodityType = this.changePlan.requestType.includes('Luce&Gas')
      ? 'Luce & Gas'
      : this.changePlan.requestType;
    const commodityTypeForProduct = this.changePlan.requestType.includes(
      'Luce&Gas'
    )
      ? 'Luce+Gas'
      : this.changePlan.requestType;
    const options = {
      product:
        this.changePlan.NewProductName.toUpperCase() +
        ' ' +
        commodityTypeForProduct,
      promo: null,
      offerType: 'ALG',
      priceTypology: this.changePlan.priceType,
      placet: 'ALG',
      commodity: commodityType,
      duration:this.changePlan.durata.replace(' Mesi', ''),
      renew: this.handlerRenew(this.changePlan.NewProductName, this.changePlan.billingFrequency),
    };
    if (options.duration === 'N/A') {
      options.duration = 'N%2FA'
    }
    return this.api
      .getCTE(options)
      .toPromise()
      .then((data) => this.downloadPdf(data))
      .catch((err) => {
        alert('Error');
      });
  }

  downloadCGF() {
    if ((!this.productGasVulnerable && this.changePlan.vulnerabilityType !== 'Età anagrafica') || (!this.productName.includes('Vulnerabile') && this.changePlan.vulnerabilityType === 'Età anagrafica')) {
      const commodityType = this.changePlan.requestType.includes('Luce&Gas')
        ? 'Luce & Gas'
        : this.changePlan.requestType;
      const options = {
        unipol: false,
        placet: 'ALG',
        commodity: commodityType,
      };
      return this.api
        .getCGF(options)
        .toPromise()
        .then((data) => this.downloadPdf(data))
        .catch((err) => {
          alert('Error');
        });
    } else {
      return this.api.getCGFVulnerableProduct()
        .toPromise()
        .then((data) => this.downloadPdf(data))
        .catch((err) => {
          console.log('ERROR: ', err)
          alert('Errore nel download del file: ')
        })
    }

  }

  private downloadPdf(data) {
    let newBlob = new Blob([data], { type: 'application/pdf' });
    let url = window.URL.createObjectURL(newBlob);
    let pwa = window.open(url);
    if (!pwa || pwa.closed || typeof pwa.closed === 'undefined') {
      alert('Please disable your Pop-up blocker and try again.');
    }
  }

  public changeCheckbox() {
    this.readAcceptance.consentsCondition =
      !this.readAcceptance.consentsCondition;
    this.controlCheckboxesConsents = !this.readAcceptance.consentsCondition;
    this.checkboxOutputConsents.emit(this.readAcceptance.consentsCondition);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/alg-change-plan/alg-change-plan-general-condition/alg-change-plan-general-condition.component.ts